export const dominikaKalabinska = {
    'meta': {
        'title': 'Psychoterapeuta Dominika Kalabińska • Centrum COLLIGO',
        'description': 'Jestem doświadczonym psychoterapeutą pracującym w nurcie łączącym w sobie różne modalności podejść psychoterapeutycznych.'
    },
    'url': {
        'address': '/torun/zespol/psychoterapeuta-dominika-kalabinska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/dominika-kalabinska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta Dominika Kalabińska'
        }
    }
}